import React, {Component} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SmsMessages from '../SmsMessages/SmsMessages';
import InputTel from '@homeaway/react-input-tel';
import {ButtonPrimary} from '@homeaway/react-buttons';
import './SmsWidget.less';

const FAILURE_MESSAGE = 'failure';
const SUCCESS_MESSAGE = 'success';

class SmsWidget extends Component {
    static propTypes = {
        /** id attribute to pass down to react-input-tel form input */
        id: PropTypes.string,
        /** Country code of the flag you want displayed initially. */
        countryCode: PropTypes.string,
        /** Translations for the countries with the key as the country code and the value as the country name. Available in Lingua at ui-development/shared --> stabInputTel. */
        countryCodes: PropTypes.objectOf(PropTypes.string),
        /** Boolean that allows consuming app to NOT display the flag dropdown. */
        displayCountryDropdown: PropTypes.bool,
        /** URL through which the bizop call should be proxied. */
        endpointUrl: PropTypes.string,
        /** EDAP eventlabel for 'user.sms.entered' event. */
        eventLabel: PropTypes.string,
        /** Translations for the various parts of the sms-widget. Available in Lingua at ui-development/shared --> smsWidget. */
        i18n: PropTypes.shape({
            cta: PropTypes.string,
            ctaShort: PropTypes.string,
            failure: PropTypes.string,
            phone_number_label: PropTypes.string,
            country_code_label: PropTypes.string,
            submit: PropTypes.string,
            success: PropTypes.string
        }),
        /** Phone number to prepopulate in the input. */
        phoneNumber: PropTypes.string,
        /** HomeAway site enum. */
        site: PropTypes.string
    }

    static defaultProps = {
        id: 'react-sms-widget',
        countryCode: 'us',
        countryCodes: {},
        displayCountryDropdown: true,
        endpointUrl: '/bizops/traveler/smsMe',
        eventLabel: 'reactsmswidget',
        i18n: {
            cta: 'Available for iOS and Android. Messaging rates may apply.',
            ctaShort: 'Available for iOS and Android.',
            failure: 'We are sorry but something went wrong sending you a SMS.',
            phone_number_label: 'Phone',
            country_code_label: 'Country Code',
            submit: 'Send',
            success: 'Success! You should have a link on your mobile device.'
        },
        phoneNumber: '',
        site: 'homeaway_us'
    }

    state = {
        countryCode: this.props.countryCode,
        phoneCode: '',
        messageShown: '',
        phoneNumber: this.props.phoneNumber
    };

    submitPhoneNumber = () => {
        if (this.state.phoneNumber) {
            this.post(`${this.state.phoneCode}${this.state.phoneNumber}`);
        }
    }

    post = (phone) => {
        const url = `${this.props.endpointUrl}?_restfully=true&phoneNumber=${phone}&site=${this.props.site}`;
        const request = {
            method: 'POST'
        };

        fetch(url, request)
            .then((response) => {
                const message = (response.status === 200 ? SUCCESS_MESSAGE : FAILURE_MESSAGE);
                this.setMessageState(message);
            }).catch(() => {
                this.setMessageState(FAILURE_MESSAGE);
            });

        if (window.edap) {
            window.edap.trigger('user.sms.entered', {
                eventlabel: this.props.eventLabel
            });
        }
    }

    setMessageState = (messageShown) => {
        this.setState({messageShown});
    }

    onPhoneChange = (e, val) => {
        this.setState({phoneNumber: val.raw, phoneCode: val.phoneCode});
    }

    onCountryCodeChange = (e, val) => {
        this.setState({countryCode: val.cc, phoneCode: val.phoneCode});
    }

    render() {
        const i18n = this.props.i18n;
        const {messageShown} = this.state;
        const widgetClasses = classNames(
            'SmsWidget',
            this.props.className,
            {
                'has-error': (messageShown === FAILURE_MESSAGE)
            }
        );

        return (
            <div className={widgetClasses}>
                <form onSubmit={this.submitPhoneNumber}>
                    <div className="input-group">
                        <div className="input-group-wrapper">
                            <InputTel
                                id={this.props.id}
                                countryCode={this.state.countryCode}
                                countryCodes={this.props.countryCodes}
                                labels={{
                                    countryCode: i18n.country_code_label,
                                    phoneNumber: i18n.phone_number_label
                                }}
                                onCountryCodeChange={this.onCountryCodeChange}
                                onPhoneChange={this.onPhoneChange}
                                phoneNumber={this.state.phoneNumber}
                                showCountrySelect={this.props.displayCountryDropdown}
                            />
                        </div>
                        <span className="input-group-btn">
                            <ButtonPrimary onClick={this.submitPhoneNumber} label={i18n.submit} />
                        </span>
                    </div>
                    <SmsMessages
                        cta={i18n.cta}
                        ctaShort={i18n.ctaShort}
                        failure={i18n.failure}
                        isFailure={messageShown === FAILURE_MESSAGE}
                        isSuccess={messageShown === SUCCESS_MESSAGE}
                        success={i18n.success}
                        valid_number={i18n.valid_number}
                    />
                </form>
            </div>
        );
    }
}

export default SmsWidget;
